import { useState } from "react";

const links = [
  { href: "#home", label: "Home" },
  { href: "#about", label: "My Story" }, // Changed to "My Story" to match new section
  { href: "#services", label: "Protection Plans" }, // Renamed for professional feel
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-[60] border-b border-gray-100 bg-white/90 backdrop-blur-md">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:py-4">
        {/* --- Logo Area --- */}
        <a href="#home" className="flex items-center gap-3 group">
          <div className="h-10 w-10 rounded-full bg-red-600 text-white grid place-items-center font-bold text-sm transition-transform group-hover:scale-110 shadow-lg shadow-red-200">
            RI
          </div>
          <div className="flex flex-col leading-none">
            <span className="text-base font-bold tracking-tight text-slate-900 group-hover:text-red-600 transition-colors">
              Ruwan Indika
            </span>
            <span className="text-[10px] font-bold uppercase tracking-widest text-red-600">
              AIA Wealth Planner
            </span>
          </div>
        </a>

        {/* --- Desktop Links --- */}
        <div className="hidden sm:flex items-center gap-8">
          <ul className="flex items-center gap-6">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-sm font-bold text-slate-600 hover:text-red-600 transition-colors uppercase tracking-wide"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop Call to Action */}
          <a
            href="#contact"
            className="rounded-full bg-red-600 px-5 py-2.5 text-sm font-bold text-white shadow-md hover:bg-red-700 hover:shadow-red-200 transition-all active:scale-95"
          >
            Free Consultation
          </a>
        </div>

        {/* --- Mobile Menu Button --- */}
        <button
          className="sm:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 hover:bg-red-50 hover:text-red-600 transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <span className="text-xl leading-none font-bold">
            {open ? "×" : "☰"}
          </span>
        </button>
      </nav>

      {/* --- Mobile Menu Drawer --- */}
      {open && (
        <div className="sm:hidden absolute top-full left-0 w-full border-b bg-white shadow-2xl animate-in slide-in-from-top duration-300">
          <ul className="px-4 py-6 grid gap-4">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-4 py-3 text-sm font-bold text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="block w-full text-center rounded-full bg-red-600 px-4 py-3 text-sm font-bold text-white shadow-lg shadow-red-100"
              >
                Free Consultation
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
